const getLeaseOffer = (paymentDetails, creditType, leaseTerm) => paymentDetails?.rates?.[creditType]?.leaseOffers?.[leaseTerm]?.[0] ?? {};
export { getLeaseOffer as default };
